module.exports = __webpack_public_path__ + "static/img/game_fail.0fe61ce2.png";